import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        this.st = new SmartTable();
    }

    add() {
        this.isSaving = true;
        this.AccountsResource
            .assignUserToGroups(this.companyId, this.account.id, this.st.selectedIds)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.user-directories.manage-account.groups-apps.add-to-groups.added'))
            .finally(() => this.isSaving = false);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/groups-apps/add-to-groups/add-account-to-groups.controller.js